import { useEffect, useState } from "react";
import TableAHSF from "../../../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import PopupAHSF from "../../../../Components/PopupAHSF";
import AddEditAdditionalSponsors from "./AddEditAdditionalSponsors";

const AdditionalSponsors = (props) => {
  const [jsonData, setJsonData] = useState({});
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [OtherProjectSupportId, setOtherProjectSupportId] = useState(null);
  const dispatch = useDispatch();

  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          ?.TeamMembersPreviousExperiencePartnerships,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "organizationName",
      ShowStatus: true,
      NmaeColumn: "اسم الجهة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "natureOfSupportAr",
      ShowStatus: true,
      NmaeColumn: "طبيعة الدعم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "supportDetails",
      ShowStatus: true,
      NmaeColumn: "تفاصيل الدعم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "supportAmountIfMonetary",
      ShowStatus: true,
      NmaeColumn: "قيمة الدعم ( في حال كان مادي)",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma : true,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setOtherProjectSupportId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/TE_OS_OtherSupportingOrganizations/DeleteTE_OS_OtherSupportingOrganizationsData",
              {
                tE_OS_OtherSupportingOrganizationsId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>{<AddEditAdditionalSponsors />}</div>,
    title: "الجهات داعمة اخرى للمشروع",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditAdditionalSponsors
          tE_OS_OtherSupportingOrganizationsId={OtherProjectSupportId}
          canEdit="edit"
        />
      </div>
    ),
    title: "الجهات داعمة اخرى للمشروع",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"tE_OS_OtherSupportingOrganizationsId"}
        valueButtonAction={"tE_OS_OtherSupportingOrganizationsId"}
        URL={`api/TE_OS_OtherSupportingOrganizations/GetTE_OS_OtherSupportingOrganizationsListData`}
        UrlBody={{
          tE_MAinTeamMembersPreviousExperiencePartnershipsId:
            props.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={" الجهات داعمة أخرى للمشورع"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};
export default AdditionalSponsors;
